* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;
}

.wrapper {
  padding: 2px;
  display: flex;
  flex-wrap: wrap;

  & > div {
    width: 50%;
  }

  .right-side-response {
    display: inline-flex;
    align-items: center;
    justify-content: end;
  }

  #responseTitle {
    text-transform: uppercase;
    color: var(--main-titles-inputs-600);
    font-size: var(--display-2-size);
    padding-left: var(--spacer);
  }

  #lastUpdated {
    font-size: var(--body-size-xsmall);
    color: var(--body-text-arrows-400);
    margin-right: var(--spacer);
  }
}

gz-response-panel-item {
  width: fit-content;
  height: auto;
}

gz-tab-group {
  gz-tab {
    position: relative;

    gz-image-repo {
      margin-top: calc(var(--spacer) * 3);

      gz-title {
        line-height: calc(var(--spacer) * 3);
        margin-bottom: var(--spacer);
        color: var(--body-text-arrows-400);
      }
    }
  }
}
